import * as React from "react"

import { cn } from "@/utils/cn"
import { cva, type VariantProps } from "class-variance-authority"

const textareaVariants = cva(
  "flex field-sizing-content w-full min-h-16 px-5 py-3 text-body-md bg-transparent rounded-3 transition-200 outline-none resize-none placeholder:text-disabled",
  {
    variants: {
      "borderInput": {
        true: "border-input",
        false: "",
      },
    },
    defaultVariants: {
      "borderInput": true,
    },
  }
)

export interface TextareaProps
  extends React.ComponentProps<"textarea">,
    VariantProps<typeof textareaVariants> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, "borderInput": borderInput, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        data-slot="textarea"
        className={cn(textareaVariants({ "borderInput": borderInput }), className)}
        {...props}
      />
    )
  }
)

Textarea.displayName = "Textarea"

export { Textarea }
